// extracted by mini-css-extract-plugin
export default {"rectangle":"slider_rectangle__nAazO","box":"slider_box__cEQ7e","arrow":"slider_arrow__59osf","values":"slider_values__woNQS"};